import React from 'react';
import './ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-container">
      <h1 className="contact-header">Contato</h1>

      {/* Mapa em cima */}
      <div className="map-section">
        <iframe
          src="https://maps.google.com/maps?q=Rua%20Alberto%20Silva%2C%201216%2C%20Lagoa%20Seca%2C%20Natal%20-%20RN&output=embed"
          title="Nossa Localização"
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>

      {/* Informações lado a lado */}
      <div className="info-row">
        <div className="info-item">
          <h3>Endereço</h3>
          <p>
            Rua Alberto Silva, 1216<br />
            Lagoa Seca, Natal - RN<br />
            CEP: 59022-300
          </p>
        </div>

        <div className="info-item">
          <h3>WhatsApp</h3>
          <p>
            <a 
              href="https://api.whatsapp.com/send/?phone=5584994078838&type=phone_number&app_absent=0" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              84 99407-8838
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
